import { motion } from "framer-motion";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { QUESTIONS } from "@/lib/quiz";

const QuizIntro = ({ onStart }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
    data-testid="quiz-intro"
  >
    <p className="text-xs font-bold uppercase tracking-[0.22em] text-accent">
      A Behavioural Finance Field Note
    </p>
    <h1 className="mt-5 font-display text-5xl font-medium leading-[0.98] tracking-tightest text-primary sm:text-6xl lg:text-7xl">
      What's Your <span className="italic">Money Personality?</span>
    </h1>
    <p className="mt-6 max-w-2xl text-base font-light leading-relaxed text-foreground/80 md:text-lg">
      A {QUESTIONS.length}-entry passbook covering how you spend, what you know about
      interest, risk and emergencies, and how you feel about money day to day. You'll
      leave with two things: your Money Personality and a Financial Well-Being Check
      out of 10.
    </p>

    <div className="mt-8 flex flex-wrap gap-x-6 gap-y-2 text-xs font-bold uppercase tracking-[0.18em] text-foreground/60">
      <span>{QUESTIONS.length} entries</span>
      <span>·</span>
      <span>~3 minutes</span>
      <span>·</span>
      <span>Free</span>
    </div>

    <div className="mt-8 flex items-start gap-3 rounded-sm border border-border bg-muted/60 p-4 text-sm text-foreground/75">
      <ShieldCheck size={18} className="mt-0.5 shrink-0 text-primary" />
      <p>
        Completely anonymous. No name or login needed — we don't ask for anything unless
        you choose to email yourself the result at the end.
      </p>
    </div>

    <motion.button
      whileHover={{ scale: 1.03 }}
      whileTap={{ scale: 0.98 }}
      onClick={onStart}
      data-testid="quiz-start-btn"
      className="group mt-10 inline-flex items-center gap-3 rounded-full bg-primary px-9 py-5 text-base font-semibold text-primary-foreground"
    >
      Open the Passbook
      <ArrowRight size={20} className="transition-transform duration-300 group-hover:translate-x-1" />
    </motion.button>

    <p className="mt-6 text-xs text-foreground/55">
      Educational only — this isn't financial advice.
    </p>
  </motion.div>
);

export default QuizIntro;
